import React from 'react';
import Wkt from 'wicket';
import DrawingManager from "react-google-maps/lib/components/drawing/DrawingManager";
const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");
const { compose, withProps, withStateHandlers } = require("recompose");
const { withScriptjs, withGoogleMap, GoogleMap, Marker, Polygon } = require("react-google-maps");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");
const googleScriptSrc = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBULUgmJkrEOfkWkrExAMCkmQRAS9GcHYk&v=3.exp&libraries=geometry,drawing";

const StyledMapWithAnInfoBox = compose(
  withProps({
    googleMapURL: googleScriptSrc,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div className="map-container" />,
    mapElement: <div style={{ height: `100%` }} />,
    center: { lat: -34.6134019, lng: -58.4993903 },
    zoom: 5,
    myStyle: [
      {
        featureType: "poi",
        stylers: [
          { visibility: "off" }
        ]
      }
    ]
  }),
  withStateHandlers(() => ({
    isOpen: false,
  }), {
    onToggleOpen: ({ isOpen }) => () => ({
      isOpen: !isOpen,
    })
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  return props.renderMethod(props);
});

export {DrawingManager, InfoBox, GoogleMap, MarkerClusterer, Marker, Polygon, StyledMapWithAnInfoBox, Wkt}


// WEBPACK FOOTER //
// ./src/containers/base/map.js